module.exports = __webpack_public_path__ + "img/xcircle.bf473f61.svg";